export default __webpack_public_path__ + "static/media/FlapYellow_diffuse-min.0c073306.jpg";